var map = {
	"./CloudComputing.jpg": 1480,
	"./GettyImages-1157048386.jpg": 3490,
	"./Logo-Extended-RGB.svg": 1377,
	"./background-largde.jpg": 6661,
	"./background-large2.jpg": 4583,
	"./fixed-structures.jpg": 1534,
	"./floating-structures.jpg": 2513,
	"./hand-cloud-bluesky.jpg": 2530,
	"./key-visual-offshore-wind.jpg": 7168,
	"./offshore-wind.jpg": 1231,
	"./sesam-insight-compressed.png": 6171,
	"./sesam-insight.png": 803,
	"./sesam-swirl.png": 960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;